// ============================================================
// DATI SITO — AutoItalia Service (Treviso)
// Fonte: scheda Google Business dell'attività.
// Alcuni dettagli (orari, email, foto) sono indicativi/demo e
// facilmente personalizzabili.
// ============================================================

export const brand = {
  name: "AutoItalia Service",
  short: "AutoItalia",
  tagline: "Centro Revisioni · Officina · Gomme",
  claim: "La forza di un grande gruppo al servizio dell'automobilista",
  phone: "0422 156 6049",
  phoneHref: "tel:+3904221566049",
  emergency: "346 618 7452",
  emergencyHref: "tel:+393466187452",
  whatsapp: "346 618 7452",
  whatsappHref: "https://wa.me/393466187452",
  email: "autoitaliaservice@hotmail.com",
  website: "autoitaliaservice.com",
  address: "Via Sant'Osvaldo, 1",
  city: "31100 Treviso (TV)",
  mapsQuery: "AUTOITALIA SERVICE Via Sant'Osvaldo 1 Treviso",
  facebook: "https://www.facebook.com/Autoitalia",
  instagram: "https://www.instagram.com/autoitaliaservice",
  rating: 4.6,
  reviewsCount: 62,
};

export const navLinks = [
  { label: "Servizi", to: "/#servizi" },
  { label: "Revisioni", to: "/#servizi" },
  { label: "Gomme", to: "/#listino" },
  { label: "Auto in vendita", to: "/auto" },
  { label: "Recensioni", to: "/#recensioni" },
  { label: "Contatti", to: "/#contatti" },
];

export const heroImages = [
  "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
];

// Servizi -------------------------------------------------------
export const services = [
  {
    id: "revisioni",
    title: "Revisioni Ufficiali",
    desc: "Centro revisioni autorizzato per auto, moto e veicoli commerciali. Prenotazione rapida e certificato immediato.",
    icon: "ClipboardCheck",
    image: "https://images.unsplash.com/photo-1723099971299-3789db53604c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    price: "da 79 €",
  },
  {
    id: "tagliandi",
    title: "Tagliandi e Manutenzione",
    desc: "Tagliando completo con ricambi di qualità, cambio olio e filtri. Manteniamo valida la garanzia della tua auto.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    price: "preventivo gratuito",
  },
  {
    id: "meccanica",
    title: "Riparazioni Meccaniche",
    desc: "Freni, frizione, distribuzione, sospensioni e interventi sul motore eseguiti da tecnici specializzati.",
    icon: "Cog",
    image: "https://images.unsplash.com/photo-1625047509248-ec889cbff17f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    price: "preventivo gratuito",
  },
  {
    id: "gomme",
    title: "Gommista",
    desc: "Vendita e montaggio pneumatici delle migliori marche, equilibratura, convergenza e cambio stagionale.",
    icon: "Disc3",
    image: "https://images.unsplash.com/photo-1675034743372-672c3c3f8377?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    price: "da 224 €",
  },
  {
    id: "elettrauto",
    title: "Elettrauto e Diagnostica",
    desc: "Diagnosi computerizzata avanzata, batterie, ricariche e riparazione impianti elettrici di ogni veicolo.",
    icon: "Cpu",
    image: "https://images.unsplash.com/photo-1729842099812-0e431813692a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    price: "diagnosi gratuita",
  },
  {
    id: "clima",
    title: "Ricarica Clima",
    desc: "Ricarica e sanificazione dell'impianto di climatizzazione per un abitacolo sempre fresco e igienizzato.",
    icon: "Snowflake",
    image: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    price: "49 € (-50%)",
  },
];

// Listino / Offerte (prezzi reali da scheda Google) ------------
export const priceList = [
  { name: "Revisione Auto", note: "Auto e veicoli commerciali leggeri", price: 79, tag: "Servizio" },
  { name: "Ricarica Clima", note: "Promozione -50% sul climatizzatore", price: 49, tag: "Offerta", highlight: true },
  { name: "Pneumatici Pirelli", note: "175/65 R14 — treno da 4", price: 267, tag: "Gomme" },
  { name: "Pneumatici Goodyear", note: "175/65 R14 — treno da 4", price: 243, tag: "Gomme" },
  { name: "Pneumatici Fulda", note: "175/65 R14 — treno da 4", price: 224, tag: "Gomme" },
  { name: "Gomme Nuove 225/50 R17", note: "98W — alte prestazioni", price: 320, tag: "Gomme" },
  { name: "Cinturato All Season 205/55 R16", note: "Pneumatico 4 stagioni", price: 370, tag: "Gomme" },
];

// Recensioni (Google, 4,6★) ------------------------------------
export const reviews = [
  { name: "Cristiana Lanzi", stars: 5, text: "Disponibili, veloci, efficienti, risolto tutto e subito." },
  { name: "flipper esse", stars: 5, text: "Passione, disponibilità, velocità. Consiglio!" },
  { name: "Giorgia Buranello", stars: 5, text: "Ormai ci conosciamo da anni... meccanico e gommista a prezzi corretti!" },
];

// Orari (indicativi, personalizzabili) -------------------------
export const openingHours = [
  { day: "Lunedì", hours: "08:00 – 12:00 / 14:00 – 18:30" },
  { day: "Martedì", hours: "08:00 – 12:00 / 14:00 – 18:30" },
  { day: "Mercoledì", hours: "08:00 – 12:00 / 14:00 – 18:30" },
  { day: "Giovedì", hours: "08:00 – 12:00 / 14:00 – 18:30" },
  { day: "Venerdì", hours: "08:00 – 12:00 / 14:00 – 18:30" },
  { day: "Sabato", hours: "08:00 – 12:00" },
  { day: "Domenica", hours: "Chiuso", closed: true },
];

// Punti di forza ------------------------------------------------
export const highlights = [
  { icon: "ShieldCheck", title: "Centro autorizzato", desc: "Revisioni ufficiali MCTC" },
  { icon: "Star", title: "4,6 su Google", desc: "62 recensioni verificate" },
  { icon: "Clock", title: "Interventi rapidi", desc: "Preventivi chiari e tempi certi" },
  { icon: "BadgePercent", title: "Prezzi corretti", desc: "Trasparenza su ricambi e manodopera" },
];

// Stats ---------------------------------------------------------
export const stats = [
  { value: "4,6★", label: "Valutazione Google" },
  { value: "62", label: "Recensioni verificate" },
  { value: "7+", label: "Servizi specializzati" },
  { value: "Gratis", label: "Preventivi e diagnosi" },
];

// Auto in vendita (vetrina) — dati dimostrativi ----------------
const img = {
  gray: "https://images.unsplash.com/photo-1630165356623-266076eaceb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHx1c2VkJTIwY2Fyc3xlbnwwfHx8fDE3ODM3MTU3MDJ8MA&ixlib=rb-4.1.0&q=85",
  lot: "https://images.unsplash.com/photo-1565043666747-69f6646db940?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHx1c2VkJTIwY2Fyc3xlbnwwfHx8fDE3ODM3MTU3MDJ8MA&ixlib=rb-4.1.0&q=85",
  suv1: "https://images.unsplash.com/photo-1618353482480-61ca5a9a7879?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxTVVYlMjBjYXJ8ZW58MHx8fHwxNzgzNzE1NzAyfDA&ixlib=rb-4.1.0&q=85",
  suv2: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxTVVYlMjBjYXJ8ZW58MHx8fHwxNzgzNzE1NzAyfDA&ixlib=rb-4.1.0&q=85",
  suv3: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxTVVYlMjBjYXJ8ZW58MHx8fHwxNzgzNzE1NzAyfDA&ixlib=rb-4.1.0&q=85",
  suv4: "https://images.pexels.com/photos/12937789/pexels-photo-12937789.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  compact1: "https://images.unsplash.com/photo-1582639510494-c80b5de9f148?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxjb21wYWN0JTIwY2FyfGVufDB8fHx8MTc4MzcxNTcwMnww&ixlib=rb-4.1.0&q=85",
  compact2: "https://images.unsplash.com/photo-1550355291-bbee04a92027?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjb21wYWN0JTIwY2FyfGVufDB8fHx8MTc4MzcxNTcwMnww&ixlib=rb-4.1.0&q=85",
  compact3: "https://images.unsplash.com/photo-1663852408695-f57f4d75a536?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxjb21wYWN0JTIwY2FyfGVufDB8fHx8MTc4MzcxNTcwMnww&ixlib=rb-4.1.0&q=85",
};

const gallery = (main) => [main, img.lot, img.suv2, img.compact1];

export const cars = [
  {
    id: "1", brand: "Citroën", model: "C3", trim: "2ª SERIE PureTech 110 S&S Exclusive",
    body: "Berlina", condition: "Usato", price: 6900, km: 113586, year: 2016, month: "03",
    fuel: "Benzina", gearbox: "Manuale", power: "110 CV", color: "Bianco", doors: 5, seats: 5,
    emission: "EURO6", consumption: "4,7 l/100km", co2: "107 g/km", neopatentati: true, location: "Treviso",
    image: img.compact1, images: gallery(img.compact1),
    features: ["Climatizzatore", "Sensori parcheggio", "Cruise control", "Bluetooth", "Cerchi in lega", "Fari LED"],
    description: "Citroën C3 in ottime condizioni, tagliandi certificati. Ideale per neopatentati e uso cittadino.",
  },
  {
    id: "2", brand: "FIAT", model: "500L", trim: "1.3 Multijet 85 CV Pop Star",
    body: "Monovolume", condition: "Usato", price: 8900, km: 83340, year: 2015, month: "03",
    fuel: "Diesel", gearbox: "Manuale", power: "85 CV", color: "Grigio", doors: 5, seats: 5,
    emission: "EURO5", consumption: "4,2 l/100km", co2: "110 g/km", neopatentati: true, location: "Treviso",
    image: img.gray, images: gallery(img.gray),
    features: ["Climatizzatore", "Radio DAB", "Volante multifunzione", "Start&Stop", "USB", "ABS"],
    description: "Spaziosa e versatile, perfetta per la famiglia. Motore diesel affidabile e consumi contenuti.",
  },
  {
    id: "3", brand: "Renault", model: "Captur", trim: "dCi 90 CV EDC Energy Intens",
    body: "SUV", condition: "Usato", price: 9900, km: 102936, year: 2016, month: "05",
    fuel: "Diesel", gearbox: "Automatico", power: "90 CV", color: "Arancio", doors: 5, seats: 5,
    emission: "EURO6", consumption: "3,8 l/100km", co2: "99 g/km", neopatentati: false, location: "Treviso",
    image: img.suv1, images: gallery(img.suv1),
    features: ["Cambio automatico", "Navigatore", "Clima automatico", "Retrocamera", "Cerchi in lega", "Keyless"],
    description: "Crossover dal look distintivo, cambio automatico EDC e dotazione completa.",
  },
  {
    id: "4", brand: "FIAT", model: "500X", trim: "1.6 E-Torq 110 CV Pop",
    body: "SUV", condition: "Usato", price: 10400, km: 123464, year: 2016, month: "03",
    fuel: "Benzina", gearbox: "Manuale", power: "110 CV", color: "Rosso", doors: 5, seats: 5,
    emission: "EURO6", consumption: "6,0 l/100km", co2: "144 g/km", neopatentati: true, location: "Treviso",
    image: img.suv2, images: gallery(img.suv2),
    features: ["Climatizzatore", "Cruise control", "Sensori parcheggio", "Bluetooth", "Cerchi 17\"", "Fendinebbia"],
    description: "Il crossover urbano dallo stile inconfondibile. Perfetto per chi cerca carattere e comfort.",
  },
  {
    id: "5", brand: "FIAT", model: "500", trim: "1.0 Hybrid Pop",
    body: "Berlina", condition: "Usato", price: 10900, km: 71987, year: 2021, month: "05",
    fuel: "Ibrida", gearbox: "Manuale", power: "70 CV", color: "Azzurro", doors: 3, seats: 4,
    emission: "EURO6", consumption: "5,3 l/100km", co2: "119 g/km", neopatentati: true, location: "Treviso",
    image: img.compact2, images: gallery(img.compact2),
    features: ["Mild Hybrid", "Schermo touch", "Apple CarPlay", "Climatizzatore", "Start&Stop", "Cerchi in lega"],
    description: "L'iconica 500 Hybrid: bassi consumi, accesso alle ZTL e tutto lo stile italiano.",
  },
  {
    id: "6", brand: "FIAT", model: "Panda", trim: "1.0 Hybrid City Life",
    body: "Berlina", condition: "Usato", price: 10900, km: 44297, year: 2021, month: "12",
    fuel: "Ibrida", gearbox: "Manuale", power: "70 CV", color: "Grigio", doors: 5, seats: 5,
    emission: "EURO6", consumption: "5,1 l/100km", co2: "115 g/km", neopatentati: true, location: "Treviso",
    image: img.compact3, images: gallery(img.compact3),
    features: ["Mild Hybrid", "Radio Bluetooth", "Climatizzatore", "Volante regolabile", "Sensori", "USB"],
    description: "La regina della città. Pochi chilometri, ibrida e adatta ai neopatentati.",
  },
  {
    id: "7", brand: "Peugeot", model: "2008", trim: "BlueHDi 100 S&S Allure",
    body: "SUV", condition: "Usato", price: 11200, km: 72735, year: 2018, month: "11",
    fuel: "Diesel", gearbox: "Manuale", power: "100 CV", color: "Grigio", doors: 5, seats: 5,
    emission: "EURO6", consumption: "4,0 l/100km", co2: "98 g/km", neopatentati: true, location: "Treviso",
    image: img.suv3, images: gallery(img.suv3),
    features: ["i-Cockpit", "Navigatore", "Clima automatico", "Cruise control", "Cerchi in lega", "Sensori"],
    description: "Peugeot 2008 Allure con l'innovativo i-Cockpit. Diesel efficiente, pronto per lunghi viaggi.",
  },
  {
    id: "8", brand: "Toyota", model: "Yaris Cross", trim: "1.5 Hybrid Trend",
    body: "SUV", condition: "Usato", price: 21900, km: 18500, year: 2023, month: "06",
    fuel: "Ibrida", gearbox: "Automatico", power: "116 CV", color: "Bianco", doors: 5, seats: 5,
    emission: "EURO6", consumption: "4,4 l/100km", co2: "100 g/km", neopatentati: true, location: "Treviso",
    image: img.suv4, images: gallery(img.suv4),
    features: ["Full Hybrid", "Safety Sense", "Navigatore", "Retrocamera", "Cerchi 17\"", "Keyless Go"],
    description: "Yaris Cross Full Hybrid, pochi chilometri e tanta tecnologia. Ottimo stato.",
  },
];

// Filtri --------------------------------------------------------
export const conditions = ["Tutti", "Nuovo", "Usato", "KM 0"];
export const carBrands = ["Tutte le marche", ...Array.from(new Set(cars.map((c) => c.brand))).sort()];
export const bodyTypes = ["Tutte", ...Array.from(new Set(cars.map((c) => c.body))).sort()];
export const fuelTypes = ["Tutti", ...Array.from(new Set(cars.map((c) => c.fuel))).sort()];

// Sede unica ----------------------------------------------------
export const locations = [
  {
    city: "Treviso", address: "Via Sant'Osvaldo, 1", zip: "31100 Treviso (TV)",
    phone: "0422 156 6049", email: "autoitaliaservice@hotmail.com",
  },
];

export const formatPrice = (n) => "€ " + n.toLocaleString("it-IT");
export const formatKm = (n) => n.toLocaleString("it-IT") + " Km";
